module.exports = __webpack_public_path__ + "static/img/s.1ee1eb30.png";